import { AssetLinks } from '@assets/assets';
import { ILoanDetails } from '@services/getAccurateEstimatedOffer';
import { formatDate } from '../../utils/dateUtils';

interface cardProps {
  id: string;
  loan: ILoanDetails;
  selectedID: string | undefined;
  handleLoanSelection: (id: string | undefined, loan: ILoanDetails) => void;
}
const LoanCard = ({ id, selectedID, loan, handleLoanSelection }: cardProps) => {
  const { currentBalance, lender, openDate, payment, remainingTerm } = loan;

  return (
    <div
      className={`iLendingCDX-card ${selectedID === id ? 'iLendingCDX-card__selected' : ''}`}
      tabIndex={0}
      aria-label={`lender: ${loan?.lender}  currentBalance :${loan?.currentBalance}`}
      onClick={() => handleLoanSelection(id, loan)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleLoanSelection(id, loan);
      }}
    >
      <h1 className="iLendingCDX-loancard-name">{lender}</h1>
      <p className="iLendingCDX-card-interest iLendingCDX-mb-4">
        Opened on {formatDate(openDate)}
        {selectedID === id && (
          <span className="iLendingCDX-loancard__selected--badge">
            <img
              src={AssetLinks.tickGrey}
              alt=""
            />
            Selected loan
          </span>
        )}
      </p>
      <p className="iLendingCDX-loancard-detail iLendingCDX-mb-2">${payment?.toLocaleString()} monthly payment </p>
      <p className="iLendingCDX-loancard-detail iLendingCDX-mb-2"> ${currentBalance?.toLocaleString()} estimated balance * </p>

      <p className="iLendingCDX-loancard-detail "> {remainingTerm} months remaining</p>
    </div>
  );
};

export default LoanCard;
